export default __webpack_public_path__ + "static/media/logogreen.f3f95c1d.png";